import React, { useMemo } from 'react';
import { CardStatusLabel, FiservCardInterface, Inscription } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { EMPTY_FIELD_VALUE } from '@/common/constants';
import useGetCardsPursesQuery from '@/modules/transaction/Cards/queries/useGetCardsPurses.query';

import useUserVerificationStatusStore from '../stores/useUserVerificationStatus.store';

const CardStatus = () => {
  const employeeId = useUserVerificationStatusStore((state) => state?.state?.employeeId);
  const cardStatus = useUserVerificationStatusStore((state) => state?.state?.cardStatus);
  const cardMailedOn = useUserVerificationStatusStore((state) => state?.state?.cardMailedOn);
  const cardCreatedAt = useUserVerificationStatusStore((state) => state?.state?.cardCreatedAt);

  const { formattedData: cardPurses, isLoading } = useGetCardsPursesQuery(employeeId);

  const card: Partial<FiservCardInterface> = useMemo(() => ({
    status: cardStatus,
    mailedDate: cardMailedOn ? dayjs(cardMailedOn).toDate() : null,
    cardRequestDate: cardCreatedAt? dayjs(cardCreatedAt).toDate() : null,
    cardPurses: cardPurses,
  }), [cardStatus, cardMailedOn, cardCreatedAt, cardPurses]);

  if (isLoading || !cardStatus) {
    return <Inscription>{EMPTY_FIELD_VALUE}</Inscription>;
  }

  return (
    <CardStatusLabel
      card={card}
      direction="row-reverse"
      pad="0px"
    />
  );
};

export default CardStatus;
